import { Toaster as Sonner, toast } from "sonner"
import { useTheme } from "../ThemeProvider"

const Toaster = ({
  ...props
}) => {
  const { resolvedTheme } = useTheme();
  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      style={{
        // Ensure toasts don't block UI interactions
        pointerEvents: 'none',
      }}
      toastOptions={{
        style: {
          // Re-enable pointer events on individual toasts
          pointerEvents: 'auto',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-surface-elevated group-[.toaster]:text-content-primary group-[.toaster]:border-border-strong group-[.toaster]:shadow-elevated",
          description: "group-[.toast]:text-content-secondary",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
